import { Validator } from '@vista-digital/validator';
import { FilmImageMediaType, filmImageMediaTypeValidator } from './media-type';
export const defaultFilmImageConfig = {
    mediaType: FilmImageMediaType.Poster,
    isDisabled: false,
    showGlow: false
};
export const filmImageConfigValidatorSchema = {
    mediaType: filmImageMediaTypeValidator,
    isDisabled: Validator.optional(Validator.boolean()),
    showGlow: Validator.optional(Validator.boolean())
};
export const filmImageConfigValidator = Validator.object(filmImageConfigValidatorSchema);
//# sourceMappingURL=config.js.map